import { BuiltInFont } from 'web';
import { posthog } from '@/providers/posthog';
import {
  FF_OLOAPTEEKKI_FONTS,
  FF_HYPERGRYPH_FONTS,
  FF_NUHIADEMAJ_FONTS,
  FF_ALKO_FONTS,
  FF_SUPER_FONTS,
  FF_ROTHO_FONTS,
  FF_KPAY_GROUP_FONTS,
  FF_ECOWORLD_BRANDING_FONTS,
  FF_CEPHEID_FONTS,
  FF_INNOCEAN_EUROPE_FONTS,
  FF_JONASHERMANNS_FONTS,
  FF_KINSTA_FONTS,
  FF_HIBOB_FONTS,
  FF_FIGMA_SANS_FONTS,
  FF_BEURER_FONTS,
  FF_MAAR_FONTS,
  FF_BONOHEALTH_FONTS,
  FF_ALEPH_FONTS,
  FF_RAKUTEN_FONTS,
  FF_RING_FONTS,
  FF_SCRIBOS_FONTS,
  FF_DEPOSCO_FONTS,
  FF_EMPIK_FONTS,
  FF_BARKBOX_FONTS,
  FF_KOMFI_FONTS,
  FF_VMFOOTWEAR_FONTS,
  FF_JOURNEYFURTHER_FONTS,
  FF_NOBEARS_FONTS,
  FF_NVIDIA_FONTS,
  FF_OPERA_FONTS,
  FF_SAMURAI_FONTS,
  FF_VOLVO_FONTS,
  FF_SAMY_FONTS,
  FF_BUSUU_FONTS,
  FF_SPAFAX_FONTS,
  FF_TEAM5PM_FONTS,
  FF_LLBEAN_FONTS,
  FF_A16Z_FONTS,
  FF_PUNKLE_FONTS,
  FF_PREDATOR_GROUP_FONTS,
  FF_STRATEYRANT_FONTS,
  FF_DUNLOP_FONTS,
  FF_AND_OR_FONTS,
  FF_LINDEX_FONTS,
  FF_JAN_GERICKE_FONTS,
  FF_METROPOLIS_FONTS,
  FF_AROSOLUCIONES_FONTS,
  FF_MINTHC_FONTS,
  FF_WOLFE_FONTS,
  FF_META_CREATIVE_X_FONTS,
  FF_POLYMATHTEXT_FONTS,
  FF_JOURNEY_FONTS,
  FF_ENCENDER_FONTS,
  FF_EUCLID_SQUARE_FONTS,
  FF_OPG_FONTS,
  FF_OUTBREAKER_FONTS,
  FF_WEAVY_TEST_FONTS,
  FF_VIRGIN_SCRIPTY_FONTS,
  FF_VACIER_FONTS,
  FF_45AI_FONTS,
  FF_UROSKRA77_FONTS,
  FF_STAPLES_FONTS,
  FF_CHRISTHORPE1_FONTS,
  FF_OSTRACON_FONTS,
  FF_GOODSTUPH_FONTS,
  FF_OMRE_FONTS,
  FF_CAPGEMINI_FONTS,
  FF_OLIVER_OLEJAR_FONTS,
  FF_OLIVER_WYMAN_FONTS,
  FF_TREZION_FONTS,
  FF_OPG_PLUS_FONTS,
  FF_DELIVEROO_FONTS,
  FF_COINSHARES_FONTS,
  FF_AMAZON_JP_FONTS,
  FF_WOLF_KASH_FONTS,
  FF_HOT_DESK_FONTS,
  FF_WALLACHMATTHEW_FONTS,
  FF_S_B_FONTS,
  FF_ADVANCEGROUP_FONTS,
  FF_365SCORES_FONTS,
  FF_SPECIALGROUP_FONTS,
  FF_TASKFORCE_FONTS,
  FF_CHEIL_FONTS,
  FF_PLURITY_FONTS,
  FF_LIBRIO_FONTS,
  FF_WILLHABEN_FONTS,
  FF_FORD_FONTS,
} from '@/consts/featureFlags';

interface BaseFontConfig {
  value: BuiltInFont;
  label: string;
}

interface CompanyFontConfig extends BaseFontConfig {
  featureFlag: string;
}

// Base fonts available to all users
export const BASE_FONTS: readonly BaseFontConfig[] = [
  { value: 'Nunito', label: 'Nunito' },
  { value: 'DMSans', label: 'DM Sans' },
  { value: 'Caveat', label: 'Caveat' },
  { value: 'CrimsonText', label: 'Crimson Text' },
  { value: 'EBGaramond', label: 'EB Garamond' },
  { value: 'Exo2', label: 'Exo 2' },
  { value: 'FiraCode', label: 'Fira Code' },
  { value: 'IBMPlexSans', label: 'IBM Plex Sans' },
  { value: 'Inter', label: 'Inter' },
  { value: 'InterTight', label: 'Inter Tight' },
  { value: 'JetBrainsMono', label: 'JetBrains Mono' },
  { value: 'Pacifico', label: 'Pacifico' },
  { value: 'Lobster', label: 'Lobster' },
  { value: 'Karla', label: 'Karla' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'SpaceMono', label: 'Space Mono' },
  { value: 'RobotoSlab', label: 'Roboto Slab' },
  { value: 'PlayfairDisplay', label: 'Playfair Display' },
  { value: 'LibreBaskerville', label: 'Libre Baskerville' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'SpaceGrotesk', label: 'Space Grotesk' },
  { value: 'SourceCodePro', label: 'Source Code Pro' },
  { value: 'Sacramento', label: 'Sacramento' },
  { value: 'Vollkorn', label: 'Vollkorn' },
  { value: 'WorkSans', label: 'Work Sans' },
  { value: 'OpenSans', label: 'Open Sans' },
  { value: 'Outfit', label: 'Outfit' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Merriweather', label: 'Merriweather' },
  { value: 'Kanit', label: 'Kanit' },
  { value: 'JosefinSans', label: 'Josefin Sans' },
  { value: 'Figtree', label: 'Figtree' },
  { value: 'Arimo', label: 'Arimo' },
  { value: 'Arapey', label: 'Arapey' },
  { value: 'BarlowCondensed', label: 'Barlow Condensed' },
  { value: 'SofiaSansExtraCondensed', label: 'Sofia Sans Extra Condensed' },
  { value: 'BebasNeue', label: 'Bebas Neue' },
  { value: 'SourceSans3', label: 'Source Sans 3' },
  { value: 'NotoSans', label: 'Noto Sans' },
  { value: 'NotoSansJP', label: 'Noto Sans JP' },
  { value: 'PlusJakartaSans', label: 'Plus Jakarta Sans' },
  { value: 'Rubik', label: 'Rubik' },
  { value: 'Workbench', label: 'Workbench' },
  { value: 'Epilogue', label: 'Epilogue' },
  { value: 'Syncopate', label: 'Syncopate' },
];

// Company-specific fonts
export const COMPANY_FONTS: readonly CompanyFontConfig[] = [
  // Oloapteekki
  { value: 'Nils', label: 'Nils', featureFlag: FF_OLOAPTEEKKI_FONTS },
  // Hypergryph
  { value: 'HarmonyOSSans', label: 'HarmonyOS Sans', featureFlag: FF_HYPERGRYPH_FONTS },
  { value: 'HarmonyOSSansCondensed', label: 'HarmonyOS Sans Condensed', featureFlag: FF_HYPERGRYPH_FONTS },
  { value: 'HarmonyOSSansNaskhArabic', label: 'HarmonyOS Sans Naskh Arabic', featureFlag: FF_HYPERGRYPH_FONTS },
  { value: 'HarmonyOSSansNaskhArabicUI', label: 'HarmonyOS Sans Naskh Arabic UI', featureFlag: FF_HYPERGRYPH_FONTS },
  { value: 'HarmonyOSSansSC', label: 'HarmonyOS Sans SC', featureFlag: FF_HYPERGRYPH_FONTS },
  { value: 'HarmonyOSSansTC', label: 'HarmonyOS Sans TC', featureFlag: FF_HYPERGRYPH_FONTS },

  // Nuhiademaj
  { value: 'SeasonMix', label: 'Season Mix', featureFlag: FF_NUHIADEMAJ_FONTS },
  { value: 'ItalianPlateNo1', label: 'Italian Plate No1', featureFlag: FF_ALKO_FONTS },
  { value: 'ItalianPlateNo2Mono', label: 'Italian Plate No2 Mono', featureFlag: FF_ALKO_FONTS },
  // Rotho fonts
  { value: 'AvenirNextW1G', label: 'Avenir Next W1G', featureFlag: FF_ROTHO_FONTS },
  { value: 'AvenirNextW1GCondensed', label: 'Avenir Next W1G Condensed', featureFlag: FF_ROTHO_FONTS },
  { value: 'AvenirNextW1GSemiCondensed', label: 'Avenir Next W1G Semi Condensed', featureFlag: FF_ROTHO_FONTS },
  // Super fonts
  { value: 'RobotoFlexSuperCondensed', label: 'Roboto Flex Super Condensed', featureFlag: FF_SUPER_FONTS },
  { value: 'RobotoFlexSuperExtended', label: 'Roboto Flex Super Extended', featureFlag: FF_SUPER_FONTS },
  // Kpay Group fonts
  { value: 'NeueHaasGroteskDisplayPro', label: 'Neue Haas Grotesk Display Pro', featureFlag: FF_KPAY_GROUP_FONTS },
  // EcoWorld Branding fonts
  { value: 'EcoWorldSans', label: 'EcoWorld Sans', featureFlag: FF_ECOWORLD_BRANDING_FONTS },
  { value: 'EcoWorldSerif', label: 'EcoWorld Serif', featureFlag: FF_ECOWORLD_BRANDING_FONTS },
  // Cepheid fonts: verified Regular/Bold pairs only; Light/Semibold need corrected italic metadata.
  { value: 'CepheidSans', label: 'Cepheid Sans', featureFlag: FF_CEPHEID_FONTS },
  { value: 'CepheidSansPro', label: 'Cepheid Sans Pro', featureFlag: FF_CEPHEID_FONTS },
  // Newly supplied Helvetica Neue LT Std: normal, condensed, extended and outline variants.
  { value: 'HelveticaNeueLTStd', label: 'Helvetica Neue LT Std', featureFlag: FF_CEPHEID_FONTS },
  { value: 'HelveticaNeueLTStdCondensed', label: 'Helvetica Neue LT Std Condensed', featureFlag: FF_CEPHEID_FONTS },
  { value: 'HelveticaNeueLTStdExtended', label: 'Helvetica Neue LT Std Extended', featureFlag: FF_CEPHEID_FONTS },
  { value: 'HelveticaNeueLTStdOutline', label: 'Helvetica Neue LT Std Outline', featureFlag: FF_CEPHEID_FONTS },
  // INNOCEAN Europe fonts
  { value: 'GenesisSansHeadOffice', label: 'Genesis Sans Head Office', featureFlag: FF_INNOCEAN_EUROPE_FONTS },
  { value: 'GenesisSansTextOffice', label: 'Genesis Sans Text Office', featureFlag: FF_INNOCEAN_EUROPE_FONTS },
  { value: 'HyundaiSansHeadOffice', label: 'Hyundai Sans Head Office', featureFlag: FF_INNOCEAN_EUROPE_FONTS },
  { value: 'HyundaiSansTextOffice', label: 'Hyundai Sans Text Office', featureFlag: FF_INNOCEAN_EUROPE_FONTS },
  { value: 'RGCironText', label: 'RG Ciron Text', featureFlag: FF_INNOCEAN_EUROPE_FONTS },
  // Jonashermanns fonts
  { value: 'DecathlonBrand', label: 'Decathlon Brand', featureFlag: FF_JONASHERMANNS_FONTS },
  { value: 'DecathlonDisplay', label: 'Decathlon Display', featureFlag: FF_JONASHERMANNS_FONTS },
  { value: 'DecathlonText', label: 'Decathlon Text', featureFlag: FF_JONASHERMANNS_FONTS },
  // Kinsta fonts
  { value: 'RecklessNeue', label: 'Reckless Neue', featureFlag: FF_KINSTA_FONTS },
  // Figma Sans (internal cohort — Figma's official brand font)
  { value: 'FigmaSans', label: 'Figma Sans', featureFlag: FF_FIGMA_SANS_FONTS },
  // Hibob fonts
  { value: 'Champion', label: 'Champion', featureFlag: FF_HIBOB_FONTS },
  { value: 'Sentinel', label: 'Sentinel', featureFlag: FF_HIBOB_FONTS },
  { value: 'GothamSSm', label: 'Gotham', featureFlag: FF_HIBOB_FONTS },
  // Beurer fonts
  { value: 'MagnoliaScript', label: 'Magnolia Script', featureFlag: FF_BEURER_FONTS },
  { value: 'Nexa', label: 'Nexa', featureFlag: FF_BEURER_FONTS },
  // Maar fonts
  { value: 'NaturaDisplay', label: 'Natura Display', featureFlag: FF_MAAR_FONTS },
  { value: 'VersosTest', label: 'Versos Test', featureFlag: FF_MAAR_FONTS },
  { value: 'NaturaEKOS', label: 'Natura EKOS', featureFlag: FF_MAAR_FONTS },

  // Aleph fonts
  { value: 'Altform', label: 'Altform', featureFlag: FF_ALEPH_FONTS },

  // Rakuten fonts
  { value: 'RakutenSans', label: 'Rakuten Sans', featureFlag: FF_RAKUTEN_FONTS },
  // Ring fonts
  { value: 'EmberModernDisplay', label: 'Ember Modern Display', featureFlag: FF_RING_FONTS },
  { value: 'EmberModernText', label: 'Ember Modern Text', featureFlag: FF_RING_FONTS },
  { value: 'RingSans', label: 'Ring Sans', featureFlag: FF_RING_FONTS },
  // Scribos fonts
  { value: 'Arial', label: 'Arial', featureFlag: FF_SCRIBOS_FONTS },
  { value: 'ArialNarrow', label: 'Arial Narrow', featureFlag: FF_SCRIBOS_FONTS },
  { value: 'ArialRounded', label: 'Arial Rounded', featureFlag: FF_SCRIBOS_FONTS },
  { value: 'Helvetica', label: 'Helvetica', featureFlag: FF_SCRIBOS_FONTS },
  { value: 'HelveticaNeueLTPro', label: 'Helvetica Neue LT Pro', featureFlag: FF_SCRIBOS_FONTS },
  { value: 'OCRB0', label: 'OCR B0', featureFlag: FF_SCRIBOS_FONTS },
  // Deposco fonts
  { value: 'Gotham', label: 'Gotham', featureFlag: FF_DEPOSCO_FONTS },
  { value: 'GothamCondensed', label: 'Gotham Condensed', featureFlag: FF_DEPOSCO_FONTS },
  { value: 'GothamNarrow', label: 'Gotham Narrow', featureFlag: FF_DEPOSCO_FONTS },
  { value: 'BebasNeueBold', label: 'Bebas Neue Bold', featureFlag: FF_DEPOSCO_FONTS },
  { value: 'DegularMono', label: 'Degular Mono', featureFlag: FF_DEPOSCO_FONTS },
  { value: 'Futura', label: 'Futura', featureFlag: FF_DEPOSCO_FONTS },
  { value: 'PermanentMarker', label: 'Permanent Marker', featureFlag: FF_DEPOSCO_FONTS },
  // Empik fonts
  { value: 'EmpikPro', label: 'Empik Pro', featureFlag: FF_EMPIK_FONTS },
  // Barkbox fonts
  { value: 'ABCGintoNordCondensed', label: 'ABC Ginto Nord Condensed', featureFlag: FF_BARKBOX_FONTS },
  { value: 'Pancho', label: 'Pancho', featureFlag: FF_BARKBOX_FONTS },
  { value: 'PanchoW03', label: 'Pancho W03', featureFlag: FF_BARKBOX_FONTS },
  // Jan Gericke fonts
  { value: 'Swanstone', label: 'Swanstone', featureFlag: FF_JAN_GERICKE_FONTS },
  // Komfi fonts
  { value: 'Satoshi', label: 'Satoshi', featureFlag: FF_KOMFI_FONTS },
  // VMFootwear fonts
  { value: 'MyriadPro', label: 'Myriad Pro', featureFlag: FF_VMFOOTWEAR_FONTS },
  { value: 'MyriadProCond', label: 'Myriad Pro Condensed', featureFlag: FF_VMFOOTWEAR_FONTS },
  { value: 'MyriadProSemiCn', label: 'Myriad Pro Semi Condensed', featureFlag: FF_VMFOOTWEAR_FONTS },
  { value: 'MyriadProSemiExt', label: 'Myriad Pro Semi Extended', featureFlag: FF_VMFOOTWEAR_FONTS },
  // Journey Further fonts
  { value: 'BarbourSans', label: 'Barbour Sans', featureFlag: FF_JOURNEYFURTHER_FONTS },
  { value: 'BarbourSerif', label: 'Barbour Serif', featureFlag: FF_JOURNEYFURTHER_FONTS },
  // Nobears fonts
  { value: 'Monroe', label: 'Monroe', featureFlag: FF_NOBEARS_FONTS },
  { value: 'Manrope3', label: 'Manrope3', featureFlag: FF_NOBEARS_FONTS },
  { value: 'HelloBunny', label: 'Hello Bunny', featureFlag: FF_NOBEARS_FONTS },
  { value: 'Filsonsoft', label: 'Filsonsoft', featureFlag: FF_NOBEARS_FONTS },
  { value: 'CeraPro', label: 'Cera Pro', featureFlag: FF_NOBEARS_FONTS },
  // NVIDIA fonts
  { value: 'NVIDIASans', label: 'NVIDIA Sans', featureFlag: FF_NVIDIA_FONTS },
  // Opera fonts
  { value: 'BeVietnamPro', label: 'Be Vietnam Pro', featureFlag: FF_OPERA_FONTS },
  // Samur-ai fonts
  { value: 'GoogleSans', label: 'Google Sans', featureFlag: FF_SAMURAI_FONTS },
  // Volvo fonts
  { value: 'VolvoNovum', label: 'Volvo Novum', featureFlag: FF_VOLVO_FONTS },
  { value: 'VolvoBroadProDigital', label: 'Volvo Broad Pro Digital', featureFlag: FF_VOLVO_FONTS },
  // Samy fonts
  { value: 'BulkSans', label: 'Bulk Sans', featureFlag: FF_SAMY_FONTS },
  { value: 'BulkScript', label: 'Bulk Script', featureFlag: FF_SAMY_FONTS },
  { value: 'McLarenBespoke', label: 'McLaren Bespoke', featureFlag: FF_SAMY_FONTS },
  // Busuu fonts
  { value: 'BwNistaGrot', label: 'Bw Nista Grot', featureFlag: FF_BUSUU_FONTS },
  // Spafax fonts
  { value: 'Emirates', label: 'Emirates', featureFlag: FF_SPAFAX_FONTS },
  { value: 'HeroicCondensed', label: 'Heroic Condensed', featureFlag: FF_SPAFAX_FONTS },
  { value: 'HelveticaNeueLTProV2', label: 'Helvetica Neue LT Pro', featureFlag: FF_SPAFAX_FONTS },
  // Team5pm fonts
  { value: 'Avantt', label: 'Avantt', featureFlag: FF_TEAM5PM_FONTS },
  { value: 'FKScreamer', label: 'FK Screamer', featureFlag: FF_TEAM5PM_FONTS },
  // LLBean fonts
  { value: 'BeanCheltOT', label: 'Bean Chelt OT', featureFlag: FF_LLBEAN_FONTS },
  { value: 'FranklinGothic', label: 'Franklin Gothic', featureFlag: FF_LLBEAN_FONTS },
  { value: 'Gotham', label: 'Gotham', featureFlag: FF_LLBEAN_FONTS },
  // a16z fonts
  { value: 'ABCFavorit', label: 'ABC Favorit', featureFlag: FF_A16Z_FONTS },
  { value: 'ABCFavoritMono', label: 'ABC Favorit Mono', featureFlag: FF_A16Z_FONTS },
  { value: 'DomaineDisplay', label: 'Domaine Display', featureFlag: FF_A16Z_FONTS },
  { value: 'DomaineDisplayCondensed', label: 'Domaine Display Condensed', featureFlag: FF_A16Z_FONTS },
  { value: 'DomaineDisplayNarrow', label: 'Domaine Display Narrow', featureFlag: FF_A16Z_FONTS },
  { value: 'DomaineSansText', label: 'Domaine Sans Text', featureFlag: FF_A16Z_FONTS },
  { value: 'DomaineText', label: 'Domaine Text', featureFlag: FF_A16Z_FONTS },
  { value: 'MessinaSans', label: 'Messina Sans', featureFlag: FF_A16Z_FONTS },
  { value: 'OrpheusPro', label: 'Orpheus Pro', featureFlag: FF_A16Z_FONTS },
  { value: 'SixteenMono', label: 'Sixteen Mono', featureFlag: FF_A16Z_FONTS },
  // Punkle Agency fonts
  { value: 'HelveticaNeue', label: 'Helvetica Neue', featureFlag: FF_PUNKLE_FONTS },
  { value: 'HelveticaNeueCondensed', label: 'Helvetica Neue Condensed', featureFlag: FF_PUNKLE_FONTS },
  // Predator Group fonts
  { value: 'DDCHardware', label: 'DDC Hardware', featureFlag: FF_PREDATOR_GROUP_FONTS },
  { value: 'DDCHardwareCondensed', label: 'DDC Hardware Condensed', featureFlag: FF_PREDATOR_GROUP_FONTS },
  { value: 'DDCHardwareCompressed', label: 'DDC Hardware Compressed', featureFlag: FF_PREDATOR_GROUP_FONTS },
  { value: 'FuturaPT', label: 'Futura PT', featureFlag: FF_PREDATOR_GROUP_FONTS },
  { value: 'FuturaPTCond', label: 'Futura PT Condensed', featureFlag: FF_PREDATOR_GROUP_FONTS },
  // StrategyRant fonts
  { value: 'SundayBloom', label: 'Sunday Bloom', featureFlag: FF_STRATEYRANT_FONTS },
  // Dunlop fonts
  { value: 'DINPro', label: 'DIN Pro', featureFlag: FF_DUNLOP_FONTS },
  { value: 'DINCondensed', label: 'DIN Condensed', featureFlag: FF_DUNLOP_FONTS },
  // and-or fonts
  { value: 'TTCommonsPro', label: 'TT Commons Pro', featureFlag: FF_AND_OR_FONTS },
  { value: 'TTCommonsProCompact', label: 'TT Commons Pro Compact', featureFlag: FF_AND_OR_FONTS },
  { value: 'TTCommonsProCondensed', label: 'TT Commons Pro Condensed', featureFlag: FF_AND_OR_FONTS },
  { value: 'TTCommonsProExpanded', label: 'TT Commons Pro Expanded', featureFlag: FF_AND_OR_FONTS },
  { value: 'TTCommonsProMono', label: 'TT Commons Pro Mono', featureFlag: FF_AND_OR_FONTS },
  // Lindex fonts
  { value: 'LindexSans', label: 'Lindex Sans', featureFlag: FF_LINDEX_FONTS },
  { value: 'LindexSerif', label: 'Lindex Serif', featureFlag: FF_LINDEX_FONTS },
  // Metropolis fonts
  { value: 'Metropolis', label: 'Metropolis', featureFlag: FF_METROPOLIS_FONTS },
  // Arosoluciones fonts
  { value: 'Fredoka', label: 'Fredoka', featureFlag: FF_AROSOLUCIONES_FONTS },
  { value: 'LuckiestGuy', label: 'Luckiest Guy', featureFlag: FF_AROSOLUCIONES_FONTS },
  { value: 'Moon', label: 'Moon', featureFlag: FF_AROSOLUCIONES_FONTS },
  { value: 'Reef', label: 'Reef', featureFlag: FF_AROSOLUCIONES_FONTS },
  { value: 'StackSansText', label: 'Stack Sans Text', featureFlag: FF_AROSOLUCIONES_FONTS },
  // Minthc fonts
  { value: 'Aeonik', label: 'Aeonik', featureFlag: FF_MINTHC_FONTS },
  // Wolfe Agency fonts
  { value: 'Visby', label: 'Visby', featureFlag: FF_WOLFE_FONTS },
  // Polymathtext fonts
  { value: 'PolymathText', label: 'Polymath Text', featureFlag: FF_POLYMATHTEXT_FONTS },
  // Weavy Test fonts
  { value: 'WeavyTest', label: 'Weavy Test', featureFlag: FF_WEAVY_TEST_FONTS }, // for test purposes. can be removed after we move to rely on workspace fonts from the DB
  { value: 'WeavyTest2', label: 'Weavy Test 2', featureFlag: FF_WEAVY_TEST_FONTS }, // for test purposes. can be removed after we move to rely on workspace fonts from the DB
  // Journey fonts
  { value: 'AwesomeSerif', label: 'Awesome Serif', featureFlag: FF_JOURNEY_FONTS },
  { value: 'AwesomeSerifTall', label: 'Awesome Serif Tall', featureFlag: FF_JOURNEY_FONTS },
  { value: 'AwesomeSerifExtraTall', label: 'Awesome Serif Extra Tall', featureFlag: FF_JOURNEY_FONTS },
  { value: 'Fellix', label: 'Fellix', featureFlag: FF_JOURNEY_FONTS },
  { value: 'TAYDreamboat', label: 'TAY Dreamboat', featureFlag: FF_JOURNEY_FONTS },
  // Meta Creative X fonts
  { value: 'AvenirNext', label: 'Avenir Next', featureFlag: FF_META_CREATIVE_X_FONTS },
  { value: 'GaramondNarrow', label: 'Garamond Narrow', featureFlag: FF_META_CREATIVE_X_FONTS },
  { value: 'HelveticaNeueWorld', label: 'Helvetica Neue World', featureFlag: FF_META_CREATIVE_X_FONTS },
  { value: 'Lato', label: 'Lato', featureFlag: FF_META_CREATIVE_X_FONTS },
  { value: 'Optimistic', label: 'Optimistic', featureFlag: FF_META_CREATIVE_X_FONTS },
  { value: 'OptimisticArbc', label: 'Optimistic Arbc', featureFlag: FF_META_CREATIVE_X_FONTS },
  { value: 'OptimisticCyrl', label: 'Optimistic Cyrl', featureFlag: FF_META_CREATIVE_X_FONTS },
  { value: 'OptimisticDeva', label: 'Optimistic Deva', featureFlag: FF_META_CREATIVE_X_FONTS },
  { value: 'OptimisticJP', label: 'Optimistic JP', featureFlag: FF_META_CREATIVE_X_FONTS },
  { value: 'OptimisticViet', label: 'Optimistic Viet', featureFlag: FF_META_CREATIVE_X_FONTS },
  { value: 'RayBanSans', label: 'Ray-Ban Sans', featureFlag: FF_META_CREATIVE_X_FONTS },
  // Encender fonts
  { value: 'KiaSignature', label: 'Kia Signature', featureFlag: FF_ENCENDER_FONTS },
  // Euclid Square fonts
  { value: 'EuclidSquare', label: 'Euclid Square', featureFlag: FF_EUCLID_SQUARE_FONTS },
  // OPG fonts
  { value: 'Exo', label: 'Exo', featureFlag: FF_OPG_FONTS },
  { value: 'SairaStencilOne', label: 'Saira Stencil One', featureFlag: FF_OPG_FONTS },
  { value: 'StardosStencil', label: 'Stardos Stencil', featureFlag: FF_OPG_FONTS },
  { value: 'StickNoBills', label: 'Stick No Bills', featureFlag: FF_OPG_FONTS },
  // OPG extra fonts
  { value: 'Videopac', label: 'Videopac', featureFlag: FF_OPG_PLUS_FONTS },
  { value: 'SistemasFontBT', label: 'SISTEMAS FONT BT', featureFlag: FF_OPG_PLUS_FONTS },
  // Outbreaker fonts
  { value: 'GoogleSansOutbreaker', label: 'Google Sans', featureFlag: FF_OUTBREAKER_FONTS },
  // virgin.com fonts
  { value: 'VirginScripty', label: 'Virgin Scripty', featureFlag: FF_VIRGIN_SCRIPTY_FONTS },
  // Vacier fonts
  { value: 'Termina', label: 'Termina', featureFlag: FF_VACIER_FONTS },
  // 45ai fonts
  { value: 'NeueFrutigerWorld', label: 'Neue Frutiger World', featureFlag: FF_45AI_FONTS },
  // uroskra77 fonts
  { value: 'A1Sans', label: 'A1 Sans', featureFlag: FF_UROSKRA77_FONTS },
  { value: 'A1Serif', label: 'A1 Serif', featureFlag: FF_UROSKRA77_FONTS },
  { value: 'A1SerifOutline', label: 'A1 Serif Outline', featureFlag: FF_UROSKRA77_FONTS },
  // Staples fonts
  { value: 'StaplesNormsPro', label: 'Staples Norms Pro', featureFlag: FF_STAPLES_FONTS },
  // christhorpe1@mac.com fonts
  { value: 'NobelUno', label: 'Nobel Uno', featureFlag: FF_CHRISTHORPE1_FONTS },
  { value: 'NoirPro', label: 'Noir Pro', featureFlag: FF_CHRISTHORPE1_FONTS },
  { value: 'Unbounded', label: 'Unbounded', featureFlag: FF_CHRISTHORPE1_FONTS },
  // Ostracon fonts
  { value: 'Mustank', label: 'Mustank', featureFlag: FF_OSTRACON_FONTS },
  { value: 'MustankGlossy', label: 'Mustank Glossy', featureFlag: FF_OSTRACON_FONTS },
  { value: 'MustankScript', label: 'Mustank Script', featureFlag: FF_OSTRACON_FONTS },
  { value: 'MustankScriptGlossy', label: 'Mustank Script Glossy', featureFlag: FF_OSTRACON_FONTS },
  { value: 'MustankScriptShadow', label: 'Mustank Script Shadow', featureFlag: FF_OSTRACON_FONTS },
  { value: 'MustankShadow', label: 'Mustank Shadow', featureFlag: FF_OSTRACON_FONTS },
  { value: 'PPMori', label: 'PP Mori', featureFlag: FF_OSTRACON_FONTS },
  // Goodstuph fonts
  { value: 'NewHero', label: 'New Hero', featureFlag: FF_GOODSTUPH_FONTS },
  // omre.co fonts
  { value: 'BeausiteClassic', label: 'Beausite Classic', featureFlag: FF_OMRE_FONTS },
  { value: 'Signifier', label: 'Signifier', featureFlag: FF_OMRE_FONTS },
  // Capgemini fonts
  { value: 'Ubuntu', label: 'Ubuntu', featureFlag: FF_CAPGEMINI_FONTS },
  // Oliver Olejar fonts
  { value: 'Haguro', label: 'Haguro', featureFlag: FF_OLIVER_OLEJAR_FONTS },
  // Oliver Wyman fonts
  { value: 'MarshSerif', label: 'Marsh Serif', featureFlag: FF_OLIVER_WYMAN_FONTS },
  // Trezion fonts
  { value: 'Saira', label: 'Saira', featureFlag: FF_TREZION_FONTS },
  // Bono Health fonts
  { value: 'Calluna', label: 'Calluna', featureFlag: FF_BONOHEALTH_FONTS },
  { value: 'Shancalluna', label: 'Shancalluna', featureFlag: FF_BONOHEALTH_FONTS },
  // Deliveroo
  { value: 'StratosDeliveroo', label: 'Stratos Deliveroo', featureFlag: FF_DELIVEROO_FONTS },
  // CoinShares fonts
  { value: 'AllianceNo1', label: 'Alliance No.1', featureFlag: FF_COINSHARES_FONTS },
  { value: 'AllianceNo2', label: 'Alliance No.2', featureFlag: FF_COINSHARES_FONTS },
  // Amazon JP fonts
  { value: 'AmazonEmberJP', label: 'Ember', featureFlag: FF_AMAZON_JP_FONTS },
  {
    value: 'EmberModernDisplayStandard',
    label: 'Ember Modern Display Standard',
    featureFlag: FF_AMAZON_JP_FONTS,
  },
  { value: 'EmberModernJP', label: 'Ember Modern JP', featureFlag: FF_AMAZON_JP_FONTS },
  // Wolf Kash fonts
  { value: 'Fredoka', label: 'Fredoka', featureFlag: FF_WOLF_KASH_FONTS },
  // Hot Desk fonts
  { value: 'GoogleSansFlex', label: 'Google Sans Flex', featureFlag: FF_HOT_DESK_FONTS },
  // wallachmatthew@gmail.com fonts
  { value: 'AeonikExtendedPro', label: 'Aeonik Extended Pro', featureFlag: FF_WALLACHMATTHEW_FONTS },
  // s-b.co.za fonts
  { value: 'Oswald', label: 'Oswald', featureFlag: FF_S_B_FONTS },
  // Advance Group fonts
  { value: 'SharpSans', label: 'Sharp Sans', featureFlag: FF_ADVANCEGROUP_FONTS },
  // 365Scores fonts
  { value: 'Sans365', label: '365 Sans', featureFlag: FF_365SCORES_FONTS },
  { value: 'SnagaArabicText', label: 'Snaga Arabic Text', featureFlag: FF_365SCORES_FONTS },
  // Special Group fonts
  { value: 'UberMove', label: 'Uber Move', featureFlag: FF_SPECIALGROUP_FONTS },
  // Taskforce fonts
  { value: 'Sora', label: 'Sora', featureFlag: FF_TASKFORCE_FONTS },
  { value: 'IndustryTest', label: 'Industry', featureFlag: FF_TASKFORCE_FONTS },
  // Plurity fonts
  { value: 'Carloschi', label: 'Carloschi', featureFlag: FF_PLURITY_FONTS },
  { value: 'CarloschiHeadline', label: 'Carloschi Headline', featureFlag: FF_PLURITY_FONTS },
  { value: 'BricolageGrotesque', label: 'Bricolage Grotesque', featureFlag: FF_PLURITY_FONTS },
  // Librio fonts
  { value: 'StickyLollipop', label: 'Sticky Lollipop', featureFlag: FF_LIBRIO_FONTS },
  { value: 'LibrioHandPrint', label: 'Librio Hand Print', featureFlag: FF_LIBRIO_FONTS },
  { value: 'GothamRounded', label: 'Gotham Rounded', featureFlag: FF_LIBRIO_FONTS },
  { value: 'BlockheadLibrio', label: 'Blockhead Librio', featureFlag: FF_LIBRIO_FONTS },
  // Cheil fonts
  { value: 'SamsungSSBody', label: 'Samsung SS Body', featureFlag: FF_CHEIL_FONTS },
  { value: 'SamsungSSHead', label: 'Samsung SS Head', featureFlag: FF_CHEIL_FONTS },
  // willhaben fonts
  { value: 'WillhabenFors', label: 'Willhaben Fors', featureFlag: FF_WILLHABEN_FONTS },
  // ford fonts
  { value: 'AmericanGrotesk', label: 'American Grotesk', featureFlag: FF_FORD_FONTS },
  { value: 'AmericanGroteskCompressed', label: 'American Grotesk Compressed', featureFlag: FF_FORD_FONTS },
];

export const BASE_BUILT_IN_FONT_KEY_SET: ReadonlySet<BuiltInFont> = new Set(
  [...BASE_FONTS, ...COMPANY_FONTS].map((f) => f.value),
);

/** Base fonts only (available to everyone, always served from static `/fonts/`). */
export const BASE_ONLY_FONT_KEY_SET: ReadonlySet<BuiltInFont> = new Set(BASE_FONTS.map((f) => f.value));

/**
 * Company fonts only. Served statically until the workspace is migrated, then from the
 * DB/presigned path when the `company-fonts-from-db` flag is on.
 */
export const COMPANY_FONT_KEY_SET: ReadonlySet<BuiltInFont> = new Set(COMPANY_FONTS.map((f) => f.value));

export type FontListOption = { value: string; label: string };

/** Workspace-uploaded family as listed in the compositor font dropdown. */
export type WorkspaceFontFamily = {
  fontFamilyKey: string;
  displayName: string;
  /** Distinct uploaded (weight, italic) faces; used by the weight/italic dropdowns. */
  styleCombinations?: { weight: number; isItalic: boolean }[];
};

function isCompanyFontEnabled(font: CompanyFontConfig): boolean {
  return !font.featureFlag || Boolean(posthog.isFeatureEnabled(font.featureFlag));
}

/**
 * Company families the current user may use, one entry per family key.
 * The same key listed under two flags is returned once, with the first label.
 */
export function eligibleCompanyFontFamilies(): FontListOption[] {
  const seen = new Set<string>();
  const families: FontListOption[] = [];
  for (const font of COMPANY_FONTS) {
    if (!isCompanyFontEnabled(font) || seen.has(font.value)) {
      continue;
    }
    seen.add(font.value);
    families.push({ value: font.value, label: font.label });
  }
  return families;
}

/**
 * Fonts shown in the compositor family dropdown: base fonts, company fonts whose
 * PostHog flag is on, then workspace uploads. A workspace family whose
 * `fontFamilyKey` matches a base or company font is omitted so the built-in entry wins.
 */
function FontsList(): { value: BuiltInFont; label: string }[];
function FontsList(workspaceFonts: readonly WorkspaceFontFamily[]): FontListOption[];
function FontsList(workspaceFonts: readonly WorkspaceFontFamily[] = []): FontListOption[] {
  const availableCompanyFonts = COMPANY_FONTS.filter(isCompanyFontEnabled);
  const listed: FontListOption[] = [...BASE_FONTS, ...availableCompanyFonts];
  const reservedKeys = new Set<string>(BASE_BUILT_IN_FONT_KEY_SET);
  for (const family of workspaceFonts) {
    if (reservedKeys.has(family.fontFamilyKey)) {
      continue;
    }
    reservedKeys.add(family.fontFamilyKey);
    listed.push({ value: family.fontFamilyKey, label: family.displayName });
  }
  return listed.sort((a, b) => a.label.localeCompare(b.label));
}

export default FontsList;
